import { sessionStorage } from "./libs/storage";

export default {
    setItem(key,value,namespace=''){
        const valueStr = typeof value === "object"?JSON.stringify(value):value
        sessionStorage.setItem(namespace+key,valueStr)
    },
    getItem(key,namespace=''){
        const value = sessionStorage.getItem(namespace+key);
        try{
            return JSON.parse(value)
        }catch(e){
            return value
        }
    }
}
